module.exports = __webpack_public_path__ + "img/icon_project02.28db5791.png";